import React from "react";
import "./table.scss";
import Text from "componets/atoms/text/text";
import "../../../styles/fontSizes.scss";
import Select from "componets/atoms/select/select";
import Pagination from "componets/molecules/pagination/pagination";

const Table = ({ activities, category, page, setPage }) => {
  const [activitiesWithFilter, setActivitiesWithFilter] =
    React.useState(activities);
  React.useEffect(() => {
    if (category == "todos") {
      setActivitiesWithFilter(activities);
    } else {
      let auxActivities = activities.filter((activity) => {
        return activity.tipoResponsables.some((value) => {
          return value.tipoResponsable.toLowerCase() == category;
        });
      });
      setActivitiesWithFilter(auxActivities);
    }
  }, [category]);
  const data = [
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante1",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante2",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante3",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante4",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante5",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante6",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante7",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante7",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante7",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante7",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante7",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante7",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante7",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante7",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante7",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante7",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante7",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante7",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante7",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante7",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante7",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante7",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante7",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante7",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante7",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante7",
    },
    {
      date: "Septiembre 20 al 11",
      activity:
        "Inscripción de candidatos a grado - segunda ceremonia (Resolución 469 de 2021 de la Rectoría)",
      responsible: "Estudiante7",
    },
  ];
  const defaultdataPerPage = 5;
  const [dataPerPage, setDataPerPage] = React.useState(defaultdataPerPage);
  var numberOfPages = Math.ceil(activitiesWithFilter.length / dataPerPage);
  React.useEffect(() => {
    setPage(1);
    numberOfPages = Math.ceil(activitiesWithFilter.length / dataPerPage);
  }, [dataPerPage]);
  const selectData = {
    groupName: "numberOfPages",
    default: defaultdataPerPage,
    options: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
    ],
  };
  return (
    <div className="table__main-container">
      <div className="table__select-container">
        <Text type="p" textSize={1}>
          Mostrar de a
        </Text>
        <Select data={selectData} setOption={setDataPerPage} />
        <Text type="p" textSize={1}>
          actividades
        </Text>
      </div>
      <table>
        <tbody>
          <tr>
            <th>
              <Text type="h" color="white" textSize={1}>
                Fecha
              </Text>
            </th>
            <th>
              <Text type="h" color="white" textSize={1}>
                Actividad
              </Text>
            </th>
            <th>
              <Text type="h" color="white" textSize={1}>
                Responsable
              </Text>
            </th>
          </tr>
          {dataPerPage &&
            activitiesWithFilter.map((actividad, index) =>
              index >= parseInt(page - 1) * parseInt(dataPerPage) &&
              index <
                parseInt(page - 1) * parseInt(dataPerPage) +
                  parseInt(dataPerPage) ? ( //Evaluar siempre con enteros.
                <tr key={index}>
                  <td>
                    <Text type="p" textSize={1}>
                      {actividad.fecha}
                    </Text>
                  </td>
                  <td>
                    <Text type="p" textSize={1}>
                      {actividad.actividad}
                    </Text>
                  </td>
                  <td>
                    <Text type="p" textSize={1}>
                      {actividad.responsables}
                    </Text>
                  </td>
                </tr>
              ) : (
                "."
              )
            )}
        </tbody>
      </table>
      <div className="table__pagination-container">
        <Text type="p" textSize={1}>{`Mostrando desde ${
          (page - 1) * dataPerPage + 1
        } hasta ${Math.min(
          page * dataPerPage,
          activitiesWithFilter.length
        )} de un total de ${activitiesWithFilter.length} actividades.`}</Text>
        <Pagination
          page={page}
          setPage={setPage}
          numberOfPages={numberOfPages}
        />
      </div>
    </div>
  );
};

export default Table;
